export class SelectionItem {

  id!: number;
  code!: string;
  description!: string;

}
